import { createFileRoute } from "@tanstack/react-router";
import LearnedPage from "../pages/Experiments/LearnedPage";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/experiments/learned")({
  component: ExperimentsLearnedRoute,
});

function ExperimentsLearnedRoute() {
  return (
    <RequireAuth require="experimentsManage">
      <LearnedPage />
    </RequireAuth>
  );
}
